@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.fallback {
  @include typography-v2-title-sm;
  @include border-radius-full;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: var(--icon-decorative-blue);
  color: var(--text-default);

  &.small {
    @include typography-v2-title-xs;

    width: 16px;
    height: 16px;
  }

  &.industry {
    background-color: var(--kg-theme);
  }

  &.financial {
    background-color: var(--purple-10);
  }

  &.macro {
    background-color: var(--chart-multi-lines-hex-3);
  }
}
